export const login = "/api/cashier/login";
export const customerVisitsURL = (customer_id: string) =>
  `/api/cashier/loyalty-statistics/customer/${customer_id}`;
export const storeURL = "/api/cashier/store";
export const getBranchesList = "/api/cashier/assigned-branches";
export const sendFixedOfflinePoints = "/api/cashier/points/add-fixed-offline-points";